import React, { useCallback, useEffect, useState } from "react";
import { Form, Input, Row, Col, Modal, Button } from "antd";

import { Container } from "./styles";
import { openNotification } from "../../../../../../components/Notification";
import { useWidth } from "../../../../../../hooks";
import { doencaService } from "../../../../../../services/resources/doencaService";
import TextArea from "antd/lib/input/TextArea";

export function ModalDoenca({ onClose, mode, codigo, reload }) {
  const [form] = Form.useForm();
  const { width } = useWidth();

  const [loading, setLoading] = useState(false);

  const [doenca, setDoenca] = useState([]);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    async function getDoenca() {
      try {
        const { data } = await doencaService.get(codigo);

        setDoenca(data);
        form.setFieldsValue({
          descricao: data?.descricao,
          fundamentacao: data?.fundamentacao,
        });
      } catch (error) {
        openNotification(
          "error",
          <strong>Erro!</strong>,
          error?.response?.data?.detail
        );
      }
    }
    if (mode !== "onCreate") {
      getDoenca();
    }
  }, [codigo, mode, form]);

  async function create() {
    try {
      setLoading(true);
      await doencaService.create(form.getFieldsValue());
      handleCloseModal();
      openNotification(
        "success",
        <strong>Doença rara criada com sucesso!</strong>
      );
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível criar o doenca!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  async function edit() {
    try {
      setLoading(true);
      await doencaService.edit(codigo, form.getFieldsValue());
      handleCloseModal();
      openNotification("success", <strong>Doença rara editada!</strong>);
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível editar o doenca!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  const footer = [
    mode === "onCreate" && (
      <Button key="submit" onClick={create} type="primary" loading={loading}>
        cadastrar
      </Button>
    ),
    mode === "onEdit" && (
      <Button
        key="submitUpdate"
        onClick={edit}
        type="primary"
        loading={loading}
      >
        atualizar
      </Button>
    ),
  ];

  return (
    <Modal
      title={
        (mode === "onCreate" && "NOVA DOENÇA RARA") ||
        (mode === "onEdit" && `EDITAR DOENÇA RARA - ${doenca?.descricao}`) ||
        (mode === "onView" && `DETALHES DA DOENÇA RARA - ${doenca?.descricao}`)
      }
      width={width > 1280 ? "40vw" : "100vw"}
      onCancel={onClose}
      visible
      footer={footer}
      centered
    >
      <Container>
        <Form form={form} name="doenca" layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item name="descricao" label={<span>descrição:</span>}>
                <Input
                  type="text"
                  placeholder="Digite a descrição"
                  autoComplete="none"
                  disabled={mode === "onView"}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                <Form.Item
                  name="fundamentacao"
                  label={<span>Fundamentação:</span>}
                >
                  <TextArea
                    autoSize
                    placeholder="Digite a fundamentação da doença rara"
                    disabled={mode === "onView"}
                  />
                </Form.Item>
              </Col>
          </Row>
        </Form>
      </Container>
    </Modal>
  );
}
